/** @enum {string} */
export const Status = Object.freeze({
  SAVED: 'saved',
  APPLIED: 'applied',
  INTERVIEWING: 'interviewing',
  OFFER: 'offer',
  REJECTED: 'rejected',
});

/** Ordered list matching Kanban column display order */
export const STATUS_ORDER = [
  Status.SAVED,
  Status.APPLIED,
  Status.INTERVIEWING,
  Status.OFFER,
  Status.REJECTED,
];

/** Display labels for each status */
export const STATUS_LABELS = Object.freeze({
  [Status.SAVED]: 'Saved',
  [Status.APPLIED]: 'Applied',
  [Status.INTERVIEWING]: 'Interviewing',
  [Status.OFFER]: 'Offer',
  [Status.REJECTED]: 'Rejected',
});

/** @enum {string} */
export const NetworkingStatus = Object.freeze({
  TARGET: 'target',
  RESEARCHED: 'researched',
  OUTREACH: 'outreach',
  SCHEDULED: 'scheduled',
  NURTURING: 'nurturing',
});

/** Ordered list matching Networking Kanban column display order */
export const NETWORKING_STATUS_ORDER = [
  NetworkingStatus.TARGET,
  NetworkingStatus.RESEARCHED,
  NetworkingStatus.OUTREACH,
  NetworkingStatus.SCHEDULED,
  NetworkingStatus.NURTURING,
];

/** Display labels for each networking status */
export const NETWORKING_STATUS_LABELS = Object.freeze({
  [NetworkingStatus.TARGET]: 'Target',
  [NetworkingStatus.RESEARCHED]: 'Researched',
  [NetworkingStatus.OUTREACH]: 'Outreach Sent',
  [NetworkingStatus.SCHEDULED]: 'Chat Scheduled',
  [NetworkingStatus.NURTURING]: 'Nurturing',
});
